import { createSlice } from "@reduxjs/toolkit";

export const kbCategorySlice = createSlice({
  name: "kbCategory",
  initialState: {
    getKbCategoryResult: false,
    getKbCategoryLoading: false,
    getKbCategoryError: false,
    addKbCategoryResult: false,
    addKbCategoryLoading: false,
    deleteKbCategoryResult: false,
  },
  reducers: {
    kbCategoryReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_KBCATEGORY":
          return {
            ...state,
            getKbCategoryResult: payload.data,
            getKbCategoryLoading: payload.loading,
            getKbCategoryError: payload.error,
          };
        case "ADD_KBCATEGORY":
          return {
            ...state,
            addKbCategoryResult: payload.data,
            addKbCategoryLoading: payload.loading,
          };
        case "DELETE_KBCATEGORY":
          return {
            ...state,
            deleteKbCategoryResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { kbCategoryReducers } = kbCategorySlice.actions;

export default kbCategorySlice.reducer;
